
import { defineComponent } from 'vue';
import { ITicket } from '@/types/models';
import api, {
  IGetRequest,
} from '@/api/admin/tickets';
import { PER_PAGE } from '@/const';
import utils from '@/utils';
import { TicketCategory, TicketPriority, TicketStatus } from '@/types/enums';

interface IForm extends IGetRequest {
  currentPage: number;
}

interface IState {
  count: number;
  tickets: ITicket[];
  formInline: IForm;
}

export default defineComponent({
  name: 'Tickets',
  data() {
    return {
      count: 0,
      tickets: [],
      isMessages: false,
      messagesCount: 0,
      messages: [],
      isAdd: false,
      formInline: {
        userName: '',
        status: TicketStatus.Dealing,
        ticketNo: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: PER_PAGE,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.count = res.count;
        this.tickets = res.tickets;
      });
    },

    getAllTicketStatus() {
      return Object.values(TicketStatus);
    },

    getTicketStatusType(ticket: ITicket) {
      if (ticket.status === TicketStatus.Closed) {
        return 'success';
      }
      if (ticket.status === TicketStatus.Dealing) {
        return 'danger';
      }
      return 'primary';
    },

    getTicketPriorityType(ticket: ITicket) {
      if (ticket.priority === TicketPriority.High) {
        return 'danger';
      }
      return 'primary';
    },

    getTicketStatus(status: TicketStatus) {
      if (status === TicketStatus.Waiting) return '待用户回复';
      if (status === TicketStatus.Dealing) return '待处理';
      if (status === TicketStatus.Closed) return '工单已关闭';
      return '全部';
    },

    getTicketPriority(status: TicketPriority) {
      return utils.getTicketPriority(status);
    },

    getTicketCategory(category: TicketCategory) {
      return utils.getTicketCategory(category);
    },

    btnSearchClick() {
      this.apiGet();
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      this.btnSearchClick();
    },

    btnViewClick(ticket: ITicket) {
      ticket.isRead = true;
      utils.pageOpen(`/admin/tickets/${ticket.ticketNo}`);
    },

    isUnread(ticket: ITicket) {
      return ticket.status === TicketStatus.Dealing && !ticket.isRead;
    },

    getClassName(ticket: ITicket) {
      if (ticket.status === TicketStatus.Dealing && !ticket.isRead) {
        return 'unread';
      }
      return '';
    },
  },
  mounted() {
    this.apiGet();
  },
});
